"use client";

import { GenericSelectorDrawer } from "./generic-selector-drawer";
import {
  ListEmza,
  AddEmza,
  EditEmza,
  DeleteLetterEmza,
} from "../../services/letter";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

export function EmzaDrawer({
  selectedLetterhead,
  onSelect,
  onClose,
  currentUserId,
}) {
  const fetchSignatures = async () => {
    const res = await ListEmza();
    return res.data.map((item) => ({
      id: item.idemzastr,
      idemza: item.idemza || 0,
      iduser: item.iduser || currentUserId || 0,
      name: item.name,
      pathimg: item.pathimg || "",
    }));
  };

  const addSignature = async (itemData) => {
    const formData = new FormData();
    formData.append("name", itemData.name);
    formData.append("pathimg", "0");
    formData.append("file", itemData.file);
    formData.append("idUser", currentUserId || 0);

    try {
      await AddEmza(formData);
      toast.success("امضا با موفقیت اضافه شد");
    } catch (err) {
      console.error(err);
      toast.error("خطا در افزودن امضا");
      throw err;
    }
  };

  const editSignature = async (id, itemData) => {
    const formData = new FormData();

    // Required fields according to API schema
    formData.append("idemza", itemData.idemza || 0); // integer
    formData.append("idemzastr", id); // string (the id passed is the string ID)
    formData.append("name", itemData.name); // string
    formData.append("pathimg", itemData.pathimg || "0"); // string
    formData.append("iduser", itemData.iduser || currentUserId || 0); // integer

    // File only if selected (optional)
    if (itemData.file) {
      formData.append("file", itemData.file); // binary
    }

    try {
      await EditEmza(id, formData);
      toast.success("امضا با موفقیت ویرایش شد");
    } catch (err) {
      console.error(err);
      toast.error("خطا در ویرایش امضا");
      throw err;
    }
  };
  const deleteSignature = async (id) => {
    const result = await Swal.fire({
      title: "حذف امضا",
      text: "آیا از حذف این امضا اطمینان دارید؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "حذف",
      cancelButtonText: "انصراف",
      customClass: {
        container: "swal2-z-index",
      },
      zIndex: 1400,
    });

    if (result.isConfirmed) {
      try {
        await DeleteLetterEmza(id);
        toast.success("امضا با موفقیت حذف شد");
      } catch (err) {
        console.error(err);
        toast.error("خطا در حذف امضا");
        throw err;
      }
    }
  };

  const fields = [
    {
      name: "name",
      label: "نام امضا",
      placeholder: "مثلاً: امضا شخصی",
      required: true,
      autoFocus: true,
    },
  ];

  return (
    <GenericSelectorDrawer
      title="امضا"
      isOpen={onClose ? true : false}
      onClose={onClose}
      selectedItem={selectedLetterhead}
      onSelect={onSelect}
      fetchItems={fetchSignatures}
      addItem={addSignature}
      editItem={editSignature}
      deleteItem={deleteSignature}
      formFields={fields}
      fileUploadId="upload-signature-image"
      fileUploadLabel="انتخاب تصویر امضا"
      emptyMessage="هیچ امضايی یافت نشد."
      selectViewTitle="انتخاب امضا"
      addViewTitle="افزودن امضا جدید"
      editViewTitle="ویرایش امضا"
      confirmLabel="تأیید انتخاب"
      addLabel="ذخیره"
      addButtonLabel="افزودن امضا جدید"
    />
  );
}
